// extracted by mini-css-extract-plugin
module.exports = {"Covered":"Covered_Covered__t_gc2","pop":"Covered_pop__2fMw8"};